var presets = {
  'transparent-blue': {
    lightColor: '#4CA6FF'
  },
  'transparent-purple': {
    lightColor: '#8473FF'
  },
  'transparent-marine': {
    lightColor: '#1FBBA1'
  },
  'transparent-tangerine': {
    lightColor: '#FF7936'
  },
  'transparent-strawberry': {
    lightColor: '#FF60A6'
  },
  'bright-magenta': {
    hoverBg: '#087CFA',
    lightColor: '#FF45ED',
    forceTypographyColors: 'dark'
  },
  'bright-magenta-dark': {
    hoverBg: '#4CA6FF',
    lightColor: '#FF45ED',
    forceTypographyColors: 'light'
  },
  'bright-pink': {
    hoverBg: '#675CE9',
    lightColor: '#E44A90',
    forceTypographyColors: 'dark'
  },
  'bright-pink-dark': {
    hoverBg: '#8473FF',
    lightColor: '#E44A90',
    forceTypographyColors: 'light'
  },
  'bright-fresh-green': {
    hoverBg: '#28B8A0',
    lightColor: '#75D64B',
    forceTypographyColors: 'dark'
  },
  'bright-fresh-green-dark': {
    hoverBg: '#1FBBA1',
    lightColor: '#75D64B',
    forceTypographyColors: 'light'
  },
  'bright-red': {
    hoverBg: '#F76707',
    lightColor: '#DD1265',
    forceTypographyColors: 'dark'
  },
  'bright-red-dark': {
    hoverBg: '#FF7936',
    lightColor: '#DD1265',
    forceTypographyColors: 'light'
  },
  'bright-orange': {
    hoverBg: '#FF318C',
    lightColor: '#FDB60D',
    forceTypographyColors: 'dark'
  },
  'bright-orange-dark': {
    hoverBg: '#FF60A6',
    lightColor: '#FDB60D',
    forceTypographyColors: 'light'
  },
  'bright-cold-green': {
    hoverBg: '#087CFA',
    lightColor: '#3BEA62',
    forceTypographyColors: 'dark'
  },
  'bright-cold-green-dark': {
    hoverBg: '#4CA6FF',
    lightColor: '#3BEA62',
    forceTypographyColors: 'light'
  },
  'bright-purple': {
    hoverBg: '#28B8A0',
    lightColor: '#6B57FF',
    forceTypographyColors: 'dark'
  },
  'bright-purple-dark': {
    hoverBg: '#1FBBA1',
    lightColor: '#6B57FF',
    forceTypographyColors: 'light'
  }
};
export { presets as default };
